import { assertCanPlayBeforeLoad } from '@/features/ctrls-and-caps/assert-can-play-before-load'
import { getOidc } from '@/features/oidc/oidc'
import { getAllFeatureFlags } from '@/lib/get-feature-flag'
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/your-play/activity-reminder')({
  component: () => <Outlet />,
  beforeLoad: async ({ context }) => {
    const oidc = await getOidc()
    if (oidc.isUserLoggedIn) {
      const userId = oidc.getDecodedIdToken()['pam-aid']
      const allFlags = await getAllFeatureFlags({ userId })
      const flagData = allFlags['nova-release-activity-reminder']
      if (!flagData?.enabled) {
        throw notFound()
      }
    }

    return assertCanPlayBeforeLoad(context.queryClient)
  },
})
